export const fitbit = {
  _id: { $oid: "63539a717e1eab5a7c61854c" },
  demo_message: "* Demo results are truncated for brevity *",
  request_parameters: { type: "product", item_id: "782866746" },
  product: {
    brand: "Fitbit",
    manufacturer: "Fitbit",
    link: "https://www.walmart.com/ip/Fitbit-Inspire-2-Black-Fitness-Tracker/782866746",
    title: "Fitbit Inspire 2 Black Fitness Tracker",
    upc: "810038852775",
    item_id: "782866746",
    product_id: "FB418BKBK",
    item_number: "6D72TYYR135R",
    description:
      "Make healthy a habit with Fitbit Inspire 2 and a free 1-year Fitbit Premium membership for new Premium users. This slim, easy-to-use fitness tracker packs 24/7 heart rate, Active Zone Minutes, activity and sleep tracking, up to 10 days of battery and more—and paired with step-by-step fitness & nutrition programs, personalized insights, and sleep tools from Premium, you have all you need for a healthier you.",
    description_html:
      "Make healthy a habit with Fitbit Inspire 2 and a free 1-year Fitbit Premium membership for new Premium users.  This slim, easy-to-use fitness tracker packs 24/7 heart rate, Active Zone Minutes, activity and sleep tracking, up to 10 days of battery and more—and paired with step-by-step fitness & nutrition programs, personalized insights, and sleep tools from Premium, you have all you need for a healthier you.",
    description_full:
      "Make healthy a habit with Fitbit Inspire 2 and a free 1-year Fitbit Premium membership for new Premium users. This slim, easy-to-use fitness tracker packs 24/7 heart rate, Active Zone Minutes, activity and sleep tracking, up to 10 days of battery and more—and paired with step-by-step fitness & nutrition programs, personalized insights, and sleep tools from Premium, you have all you need for a healthier you. Fitbit Inspire 2 Black Fitness Tracker:\n\n * Personalized health & fitness guidance with a 1-year Fitbit Premium membership for new Premium users (New Premium users only. Must activate with device. Valid payment method required. Free trial must be activated within 60 days of device activation. Cancel before free trial ends to avoid subscription fees)\n * Optimize your workout routine with a Daily Readiness Score that reveals if youâre ready to exercise or should focus on recovery (requires Fitbit Premium membership)1\n * Earn Active Zone Minutes as you progress toward your weekly 150 minutes of heart-pumping activity and use 20+ exercise modes to track goals like distance, calories burned and more\n * Track all-day activity: your steps, distance, hourly activity and calories burned. Use 24/7 heart rate to track resting heart rate & better measure calorie burn.\n * Enjoy up to 10 days of battery life for daily progress without constant charging. Varies with use and other factors &mildot;\n * Track your time in light, deep and REM sleep, then get a Sleep Score to better understand your sleep quality each night.\n * Stay inspired from the shower to the pool with this swim proof tracker (water resistant to 50 meters) and motivated by connecting with friends, competing in challenges, earning badges and celebrating goal milestones Get call, text, calendar and smartphone app notifications right on your wrist.\n * Notifications and app alerts are available on-device when your phone is nearby\n\n1 Daily Readiness requires a Fitbit Premium membership. Premium content recommendations are not available in all locales and may be in English only.",
    description_full_html:
      "Make healthy a habit with Fitbit Inspire 2 and a free 1-year Fitbit Premium membership for new Premium users.  This slim, easy-to-use fitness tracker packs 24/7 heart rate, Active Zone Minutes, activity and sleep tracking, up to 10 days of battery and more—and paired with step-by-step fitness & nutrition programs, personalized insights, and sleep tools from Premium, you have all you need for a healthier you. <p><strong>Fitbit Inspire 2 Black Fitness Tracker:</strong></p>  <ul>   <li>Personalized health &amp; fitness guidance with a 1-year Fitbit Premium membership for new Premium users (New Premium users only. Must activate with device. Valid payment method required. Free trial must be activated within 60 days of device activation. Cancel before free trial ends to avoid subscription fees)</li>   <li>Optimize your workout routine with a Daily Readiness Score that reveals if you&acirc;re ready to exercise or should focus on recovery (requires Fitbit Premium membership)1</li>   <li>Earn Active Zone Minutes as you progress toward your weekly 150 minutes of heart-pumping activity and use 20+ exercise modes to track goals like distance, calories burned and more</li>   <li>Track all-day activity: your steps, distance, hourly activity and calories burned. Use 24/7 heart rate to track resting heart rate &amp; better measure calorie burn.</li>   <li>Enjoy up to 10 days of battery life for daily progress without constant charging. Varies with use and other factors &amp;mildot;</li>   <li>Track your time in light, deep and REM sleep, then get a Sleep Score to better understand your sleep quality each night.</li>   <li>Stay inspired from the shower to the pool with this swim proof tracker (water resistant to 50 meters) and motivated by connecting with friends, competing in challenges, earning badges and celebrating goal milestones Get call, text, calendar and smartphone app notifications right on your wrist.</li>   <li>Notifications and app alerts are available on-device when your phone is nearby</li>  </ul>  <p>1 Daily Readiness requires a Fitbit Premium membership. Premium content recommendations are not available in all locales and may be in English only.</p>",
    model: "FB418BKBK",
    ratings_total: 332,
    protection_plans: [
      {
        title: "Walmart Protection Plan by Allstate - 3-Year",
        description:
          "<p>Get years of protection for just pennies a day.</p><p><b>Plan covers:</b></p><ul><li>Mechanical & Electrical Failures</li><li>Item Failures During Normal Use, or from Normal Wear & Tear</li><li>Other Common Malfunctions</li></ul><p><b>Plan includes:</b></p><ul><li>24/7 Customer Support</li><li>Easy Online Claims</li><li>Fast Repairs or Replacements</li></ul><p><b>Protect it today. Enjoy it for years.</b></p><p>Simply add a Walmart Protection Plan to your order and checkout as usual. There is no need to register your plan for it to be active. We’ll send plan details to your email address after purchase.</p><p><b>Award-winning protection backed by Allstate</b></p><p>Allstate has been protecting people and the things they love most for over 85 years. So you know your purchase is in good hands.</p>",
        item_id: "856871403",
        id: "6DB8D53F1E7644A7AE3FEDBC121AAAE3",
        is_walmart_protection_plan: true,
        image:
          "https://i5.walmartimages.com/asr/b04b2969-4200-4781-9f3a-3da0ccca5d4d.06e6f536cfdbec82e8b0108a6488901d.jpeg",
        price: {
          value: 8,
          currency_symbol: "$",
          currency: "USD",
          raw: "$8.00",
        },
      },
      {
        title: "Walmart Protection Plan by Allstate - 2-Year",
        description:
          "<p>Get years of protection for just pennies a day.</p><p><b>Plan covers:</b></p><ul><li>Mechanical & Electrical Failures</li><li>Item Failures During Normal Use, or from Normal Wear & Tear</li><li>Other Common Malfunctions</li></ul><p><b>Plan includes:</b></p><ul><li>24/7 Customer Support</li><li>Easy Online Claims</li><li>Fast Repairs or Replacements</li></ul><p><b>Protect it today. Enjoy it for years.</b></p><p>Simply add a Walmart Protection Plan to your order and checkout as usual. There is no need to register your plan for it to be active. We’ll send plan details to your email address after purchase.</p><p><b>Award-winning protection backed by Allstate</b></p><p>Allstate has been protecting people and the things they love most for over 85 years. So you know your purchase is in good hands.</p>",
        item_id: "736351207",
        id: "B1F2E601735E4799A3EE1956AF037FE5",
        is_walmart_protection_plan: true,
        image:
          "https://i5.walmartimages.com/asr/b04b2969-4200-4781-9f3a-3da0ccca5d4d.06e6f536cfdbec82e8b0108a6488901d.jpeg",
        price: {
          value: 6,
          currency_symbol: "$",
          currency: "USD",
          raw: "$6.00",
        },
      },
    ],
    home_service_plans: [
      {
        title: "Expert Help - Premium Tech Support & Security",
        description:
          '<div class="font-medium"> \t<p style="font-size: 1.05rem; padding: 1em; background-color: #f5f5f5; border-radius: 0.5em; border: 1px solid #e5e5e5;">For less than the price of a weekly coffee, you can receive one year of Premium Tech Support & Security powered by True Network Solutions. Our US-based tech experts are available 24/7 by phone, chat, or email to assist you when you need it!</p> \t<br> \t<p><b>For only $99</b>, this <b>$400 value</b> includes unlimited support for all the tech you own &mdash; computers, smart home products, printers, routers, tablets, and more.</p> \t<br> \t<p><em>What\'s included with this 1-year service?</em></p> \t<ul class="mid-gray" style="line-height: 1.75;"> \t\t<li><img src="https://truesolutions.com/assets/img/mcafee-tiny.svg" style="vertical-align: -.15em" alt="McAfee"> Total Protection to defend against viruses & online threats</li> \t\t<li>Unlimited 24/7 1-on-1 tech coaching and tech support with live multi-lingual US-based Tech Experts</li> \t\t<li>Unlimited virus removal for up to 10 devices </li> \t\t<li>Initial Setup service and ongoing support for any of your tech products, no matter where you bought them</li> \t\t<li>Access to 1 Data Recovery service: if your computer suffers a data loss, we can recover it free of charge*</li> \t\t<li>Unlimited troubleshooting, software support, and PC tune-ups</li> \t</ul> \t<br> \t<hr> \t<br> \t<p style="font-size: 1.25rem;"><i class="ld ld-QuestionCircle" style="margin-right: 0.25em; vertical-align: -0.15em;"></i>Questions? Call <a href="tel:+1-316-PRO-HELP" style="color: #0071dc;">(316) 776-4357</a> to learn more from our friendly tech team.</p> \t<br> \t<hr> \t<br> \t<p><i class="ld ld-ChatBubble" style="margin-right: 0.25em; vertical-align: -0.15em; font-weight: 600;"></i><em>How do I receive service?</em></p> \t<p style="padding-left: 1em;">Simply add this service to your cart and check out. Once purchased, you\'ll receive an email from True Network with the information needed to initiate service at your convenience. You\'ll be able to call, email, or chat 24/7/365 with a US-based tech expert</p> \t<br> \t<p><i class="ld ld-Clock" style="margin-right: 0.25em; vertical-align: -0.15em; font-weight: 600;"></i><em>How long do I receive service for? </em></p> \t<p style="padding-left: 1em;">This is a one-year service plan and does not auto-renew.</p> \t<br> \t<p> \t\t<svg style="width: 1em; margin-right: 0.25em;" viewBox="0 0 512 512"> \t\t\t<path d="M235.3 331.3C229.1 337.6 218.9 337.6 212.7 331.3L148.7 267.3C142.4 261.1 142.4 250.9 148.7 244.7C154.9 238.4 165.1 238.4 171.3 244.7L224 297.4L340.7 180.7C346.9 174.4 357.1 174.4 363.3 180.7C369.6 186.9 369.6 197.1 363.3 203.3L235.3 331.3zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 32C132.3 32 32 132.3 32 256C32 379.7 132.3 480 256 480C379.7 480 480 379.7 480 256C480 132.3 379.7 32 256 32z"/> \t\t</svg> \t\t<em>True Satisfaction</em> \t</p> \t<p style="padding-left: 1em;">True Network Solutions is committed to making sure every customer is happy with our services! We\'ll do everything possible to make sure our customers are 100% satisfied. If you would like to provide feedback on your experience or encounter any issues, we\'re ready to listen. Contact our Customer Service team 24/7 at <a href="tel:+1-316-776-4357" style="color: #0071dc;">(316) 776-4357.</a></p> \t<br> \t<sup>* We use commercially reasonable efforts to attempt to recover your lost data and files using both basic and advanced methods. Methods include but are not limited to current software and hardware techniques available as well as proprietary techniques developed for data recovery.</sup> </div> <style> \t.font-medium p, \t.font-medium li, \t.font-medium sup { \t\tfont-weight: 500; \t} </style>',
        item_id: "422702247",
        id: "018387830C2E4B49963FBA34E745726D",
        image:
          "https://i5.walmartimages.com/asr/4797f636-1d8c-4d7e-aa9b-a871d095c329.009ebf65bb7fe95faa31640aaf2dcf0a.jpeg",
        price: {
          value: 99,
          currency_symbol: "$",
          currency: "USD",
          raw: "$99.00",
        },
      },
    ],
    rating: 4.1,
    type: "Fitness Trackers",
    main_image: {
      link: "https://i5.walmartimages.com/asr/300c5cbd-1e40-4837-a75f-6788aaefed85.8f79103ab15b286aced33afaac251e4d.jpeg",
    },
    images: [
      {
        link: "https://i5.walmartimages.com/asr/300c5cbd-1e40-4837-a75f-6788aaefed85.8f79103ab15b286aced33afaac251e4d.jpeg",
        id: "4BC7B615B6F6426E9B466B5821723F16",
        zoomable: true,
      },
      {
        link: "https://i5.walmartimages.com/asr/f1da5a3b-b946-4bf0-bb89-68e63d7c3c43.7dc8614e2ca1b9d42122cff993a082b9.jpeg",
        id: "2FFFE567AA1246FCA2FBA04CAE6B1DC2",
        zoomable: true,
      },
      {
        link: "https://i5.walmartimages.com/asr/0d882bac-d3f0-445f-a842-f9326345a1ef.422606349a2dc8446e9f4b1f8d338cd6.jpeg",
        id: "E457372E7A164D75865C0CC1468FD1EC",
        zoomable: true,
      },
      {
        link: "https://i5.walmartimages.com/asr/b74e7452-2c4d-4139-b404-792aa5e88567.46f44dbada4c02a5b0f77bd8cadc5a0b.jpeg",
        id: "A7367DF4F8454D91A3F98D2A32643279",
        zoomable: true,
      },
      {
        link: "https://i5.walmartimages.com/asr/222062b6-9f9b-4b6c-a261-a488f7116d5b.364cd6cff86dcf3c68a0f0072bcc5260.jpeg",
        id: "F65BC3618A844648AA60175A223E4D6D",
        zoomable: true,
      },
    ],
    breadcrumbs: [
      { name: "Electronics", link: "https://www.walmart.com/cp/3944" },
      {
        name: "Wearable Technology",
        link: "https://www.walmart.com/cp/1229723",
      },
      { name: "Fitness Trackers", link: "https://www.walmart.com/cp/1225106" },
    ],
    specifications: [
      { name: "Features", value: "Water-Resistant, Splash Proof" },
      { name: "Brand", value: "Fitbit" },
      { name: "Assembled Product Weight", value: "1.5 in" },
      { name: "Manufacturer Part Number", value: "FB418BKBK" },
      { name: "Manufacturer", value: "Fitbit" },
      {
        name: "Assembled Product Dimensions (L x W x H)",
        value: "0.50 x 0.70 x 0.50 Inches",
      },
    ],
    buybox_winner: {
      price: 65.39,
      currency_symbol: "$",
      offers_total: 11,
      offers_from_price: {
        currency_symbol: "$",
        currency: "USD",
        raw: "$65.39",
        value: 65.39,
      },
      id: "A79637392D46473AAF0B56EE1260B95C",
      seller: {
        name: "City Supply inc.",
        id_secondary: "A67FFB97C2454A2992A9380DA21DA8DF",
        id: 5863,
        link: "https://www.walmart.com/seller/5863",
      },
      fulfillment: {
        pickup: false,
        delivery_from_store: false,
        shipping: true,
        shipping_message:
          "Free shipping, arrives by Thu, Oct 27 to Bentonville, 72712",
        message: "Free shipping, arrives by Thu, Oct 27 to Bentonville, 72712",
        zipcode: "72712",
      },
      availability: { raw: "IN_STOCK", in_stock: true, preorder: false },
    },
    dimensions: "0.50 x 0.70 x 0.50 Inches",
    variants: [
      {
        item_id: "782866746",
        product_id: "6D72TYYR135R",
        link: "https://www.walmart.com/ip/782866746",
        in_stock: true,
        price: 65.39,
        images: [
          {
            link: "https://i5.walmartimages.com/asr/300c5cbd-1e40-4837-a75f-6788aaefed85.8f79103ab15b286aced33afaac251e4d.jpeg",
            id: "4BC7B615B6F6426E9B466B5821723F16",
            zoomable: true,
          },
          {
            link: "https://i5.walmartimages.com/asr/f1da5a3b-b946-4bf0-bb89-68e63d7c3c43.7dc8614e2ca1b9d42122cff993a082b9.jpeg",
            id: "2FFFE567AA1246FCA2FBA04CAE6B1DC2",
            zoomable: true,
          },
          {
            link: "https://i5.walmartimages.com/asr/0d882bac-d3f0-445f-a842-f9326345a1ef.422606349a2dc8446e9f4b1f8d338cd6.jpeg",
            id: "E457372E7A164D75865C0CC1468FD1EC",
            zoomable: true,
          },
          {
            link: "https://i5.walmartimages.com/asr/b74e7452-2c4d-4139-b404-792aa5e88567.46f44dbada4c02a5b0f77bd8cadc5a0b.jpeg",
            id: "A7367DF4F8454D91A3F98D2A32643279",
            zoomable: true,
          },
          {
            link: "https://i5.walmartimages.com/asr/222062b6-9f9b-4b6c-a261-a488f7116d5b.364cd6cff86dcf3c68a0f0072bcc5260.jpeg",
            id: "F65BC3618A844648AA60175A223E4D6D",
            zoomable: true,
          },
        ],
        criteria: [{ name: "actual_color", value: "black" }],
      },
      {
        item_id: "324765345",
        product_id: "2MASTHPDPL5T",
        link: "https://www.walmart.com/ip/324765345",
        in_stock: true,
        price: 78.95,
        images: [
          {
            link: "https://i5.walmartimages.com/asr/132c00d6-f44e-49a1-bc06-2fca6fa2b694.d42d208b64661a28f277e7e6b59f1aca.jpeg",
            id: "07FA70C9500745CF837490FB7A7C6789",
            zoomable: true,
          },
          {
            link: "https://i5.walmartimages.com/asr/26f1b146-0260-48c2-abc3-d8a83707fca1.3036e53b16a419f521bd78b3f9a869f4.jpeg",
            id: "41A3EDA923F2421AA6A89EA661CEA6C9",
            zoomable: true,
          },
          {
            link: "https://i5.walmartimages.com/asr/121b986d-51a4-4865-bda9-23b6c8cfa4e3.410a0cb5ac899c5e94a770727caf45b3.jpeg",
            id: "E31F839D91AD4886BB67D2DB4C8C25FC",
            zoomable: true,
          },
          {
            link: "https://i5.walmartimages.com/asr/8c1186a4-e6bc-4b13-a24e-01e694f6e3b5.42ad75da8aaefc9603120abc40775aaa.jpeg",
            id: "20E5B2B0F4244AB8A0455D5604ACEB13",
            zoomable: true,
          },
          {
            link: "https://i5.walmartimages.com/asr/c13f85f1-a92e-467f-a90c-0c54142b46e6.aaca4ad0a968f35d44d51721ebbf12f3.jpeg",
            id: "EC078C492C674D84A49BFFD7E7C93795",
            zoomable: true,
          },
        ],
        criteria: [{ name: "actual_color", value: "pink" }],
      },
      {
        item_id: "684731248",
        product_id: "79LLFO25BTMP",
        link: "https://www.walmart.com/ip/684731248",
        in_stock: true,
        price: 74.95,
        images: [
          {
            link: "https://i5.walmartimages.com/asr/e0d972ee-a695-47cd-b079-fd665299adfc.e5ef758e30d7706e4d7c06c1f14d5ba7.jpeg",
            id: "AE46D59BB4CA4DA0A9017FD9D6851A63",
            zoomable: true,
          },
          {
            link: "https://i5.walmartimages.com/asr/e9cfe46b-827b-4e60-962a-6372bda5c609.46817598bc0a90226bd5a4528c8e0eab.jpeg",
            id: "6C861D2683C3427DBB10D9BDC80A81E1",
            zoomable: true,
          },
          {
            link: "https://i5.walmartimages.com/asr/e4f3e7b3-17b2-429b-9a60-705dadc5c4ad.54fd3c982c174f04a986d376195b4e90.jpeg",
            id: "645F1D256680473A9D327C17BAF34DBA",
            zoomable: true,
          },
          {
            link: "https://i5.walmartimages.com/asr/86f8357f-6634-4700-8ad8-776b9e995406.46cea20079e9c48b48b17b3f3a84701c.jpeg",
            id: "6D5EE24E140346C3AE5504E16DBFAC59",
            zoomable: true,
          },
          {
            link: "https://i5.walmartimages.com/asr/a3149402-3057-4985-a0aa-74b5ffa409e3.aee713ddb60e6abb31f4d4ffd61e68d5.jpeg",
            id: "617B154A195E4038B5C0E4124E688F75",
            zoomable: true,
          },
        ],
        criteria: [{ name: "actual_color", value: "white" }],
      },
    ],
  },
};
